var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");
lorem.supplemental = require("./supplemental");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/lorem/index.js
 ** module id = 463
 ** module chunks = 0
 **/